import { Outlet, Link } from 'react-router-dom';

export default function App() {
  return (
    <div className="app">

      <main className="content">
        <Outlet />
      </main>

    </div>
  );
}
